export default __webpack_public_path__ + "static/media/1000+ Satisfied Clients.843f67d6.png";